import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'

import ReaderNavigation from './ReaderNavigation'
import { toggleReaderNavigationModal } from '../actions'

class ReaderNavigationContainer extends React.Component {
  static propTypes = {
    chapterID: PropTypes.string.isRequired,
    pageID: PropTypes.string.isRequired,
    displaySectionNumbers: PropTypes.bool.isRequired,
    responsiveDeviceWidth: PropTypes.number.isRequired,
    open: PropTypes.bool.isRequired,
    toggleReaderNavigationModal: PropTypes.func,
  }

  state = {
    isModal: $(window).width() < this.props.responsiveDeviceWidth,
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({
      isModal: $(window).width() < this.props.responsiveDeviceWidth,
    })
  }

  render() {
    const isModal = this.state.isModal
    return (
      <div>
        {isModal ? (
          <div>
            <Modal
              open={this.props.open}
              onClose={() => this.props.toggleReaderNavigationModal(false)}
              classNames={{ modal: 'ReaderToolbar_Modal below-navbar' }}
            >
              <ReaderNavigation
                chapterID={this.props.chapterID}
                pageID={this.props.pageID}
                displaySectionNumbers={this.props.displaySectionNumbers}
              />
            </Modal>
          </div>
        ) : (
          <ReaderNavigation
            chapterID={this.props.chapterID}
            pageID={this.props.pageID}
            displaySectionNumbers={this.props.displaySectionNumbers}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    responsiveDeviceWidth: state.responsiveDeviceWidth,
    open: state.showReaderNavigationModal,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleReaderNavigationModal: readerNavigationModalState => {
      dispatch(toggleReaderNavigationModal(readerNavigationModalState))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReaderNavigationContainer)
